import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=093c89ae&scoped=true&"
import script from "./FileCard.vue?vue&type=script&lang=ts&"
export * from "./FileCard.vue?vue&type=script&lang=ts&"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=093c89ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c89ae",
  null
  
)

export default component.exports